module.exports = {
	"name": "Sweeting",
	"foodRecommendations": [
		{
			"text": "They have rolled up ice cream like the kinda shit you see on Tasty. They make it right in front of you which is pretty cool. It's a little expensive and tastes like normal ice cream but the experience is worth it.",
			"person": "Shivangi Sharma"
		}
	],
	"address": "1213 S University Ave, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.275198,
		"lng": -83.733883
	},
	"catImage": "greenstar.png",
	"totalCats": 1,
	"totalMisc": 0,
	"categories": {
		"location": 1,
		"fooddrink": 1,
		"dessert": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/sweeting.json
// module id = 984
// module chunks = 0